import { render, staticRenderFns } from "./ItemsKitRentUpdate.vue?vue&type=template&id=f842ef80&scoped=true&"
import script from "./ItemsKitRentUpdate.vue?vue&type=script&lang=js&"
export * from "./ItemsKitRentUpdate.vue?vue&type=script&lang=js&"
import style0 from "./ItemsKitRentUpdate.vue?vue&type=style&index=0&id=f842ef80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f842ef80",
  null
  
)

export default component.exports